<div class="flex justify-start">
	<div class="px-3 py-2 overflow-hidden">
		<span
			class="shimmer-text text-sm block"
			[class.text-exit]="animationState() === AnimationState.EXITING"
			[class.text-enter]="animationState() === AnimationState.ENTERING"
			aria-live="polite"
			aria-atomic="true"
			[innerHTML]="displayedText()"
		></span>
	</div>
</div>
